import { currentDomainOrganisation } from '@/api/modules/app.api.js';
import { userSession } from '@/api/modules/login.api.js';
import Config from '@/services/config.service';
import appAPI from '@/api/modules/app.api.js';
const appConfig = new Config();

export default [
  {
    path: 'accounts',
    name: 'Accounts',
    component: () => import('./views/Accounts.vue'),
    beforeEnter: async (to, from, next) => {
      if (appConfig.isSaas && !currentDomainOrganisation.value) {
        await appAPI.getCurrentDomainOrganisation();
      }
      if (!userSession.isSuperuser() && appConfig.isSaas && currentDomainOrganisation.value) {
        return next({
          name: 'OrganisationDetail',
          params: {
            locale: to.params.locale,
            id: String(currentDomainOrganisation.value.id),
          },
        });
      } else if (!userSession.isSuperuser() && !appConfig.isSaas && userSession.isDelegatedAdmin()) {
        return next({
          name: 'Organisations',
          params: {
            locale: to.params.locale,
          },
        });
      } else if (!appConfig.isSaas && !userSession.isSuperuser() && !userSession.isDelegatedAdmin()) {
        return next({
          name: '403Page',
          params: {
            locale: to.params.locale,
          },
        });
      }
      return next();
    },
  },
];